import React from "react";
import AdminStacksComponent from "../../../components/Admin/Stacks";

export default function AdminStacksPage() {
    return <AdminStacksComponent />;
}
